<div class="pricing-modal-shell">
  <div class="pricing-modal-header">
    <div class="pricing-modal-title-block">
      <span class="pricing-modal-eyebrow">Invoice builder</span>
      <h4 class="pricing-modal-title mb-1">
        <i class="bi bi-tags-fill text-primary me-2"></i>
        {{ dialogTitle }}
      </h4>
      <p class="pricing-modal-subtitle mb-0">
        Select the services that apply to this consultation and capture any amount already paid.
      </p>
    </div>

    <button
      type="button"
      class="btn-close pricing-modal-close"
      aria-label="Close"
      (click)="closeIfAllowed()"
    ></button>
  </div>

  <div class="pricing-modal-body">
    @if (isLoading) {
      <div class="text-center py-4 text-muted">
        <div class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></div>
        Loading consultation pricing...
      </div>
    }

    @if (!isLoading) {
      @if (errorMessage) {
        <div class="alert alert-danger d-flex align-items-center">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          <span>{{ errorMessage }}</span>
        </div>
      }

      <div class="alert alert-info d-flex align-items-start pricing-note">
        <i class="bi bi-info-circle-fill me-2 mt-1"></i>
        <div>
          Choose the pricing items that apply to this booking. The total updates as you select
          services.
        </div>
      </div>

      <div class="pricing-layout">
        <section class="pricing-list-panel">
          <div class="section-heading">
            <div>
              <h6 class="mb-1 fw-semibold">Available items</h6>
              <small class="text-muted">Fetched from consultation pricing settings.</small>
            </div>

            <span class="badge text-bg-light border text-dark"
              >{{ pricingItems.length }} items</span
            >
          </div>

          @if (pricingItems.length === 0) {
            <div class="empty-state">
              <i class="bi bi-receipt-cutoff fs-1 d-block mb-2"></i>
              No consultation pricing items are available yet.
            </div>
          } @else {
            <div class="pricing-list">
              @for (item of pricingItems; track item.id) {
                <label class="pricing-item" [class.is-selected]="isSelected(item.id)">
                  <div class="pricing-item__left">
                    <input
                      class="form-check-input m-0"
                      type="checkbox"
                      [checked]="isSelected(item.id)"
                      (change)="toggleSelection(item.id, $any($event.target).checked)"
                    />

                    <div class="pricing-item__text">
                      <div class="fw-semibold">{{ item.serviceItem }}</div>
                      <small class="text-muted">Billable consultation service</small>
                    </div>
                  </div>

                  <div class="pricing-item__price">R{{ item.cost | number: '1.2-2' }}</div>
                </label>
              }
            </div>
          }
        </section>

        <aside class="pricing-summary-panel">
          <div class="summary-card summary-card--accent">
            <div class="text-muted small mb-1">Selected total</div>
            <div class="summary-total">R{{ selectedTotal | number: '1.2-2' }}</div>
            <div class="summary-meta">{{ selectedItemIds.length }} item(s) selected</div>
          </div>

          @if (selectedItems.length > 0) {
            <div class="summary-card">
              <div class="text-muted small mb-2">Selected services</div>
              <div class="selected-chips">
                @for (item of selectedItems; track item.id) {
                  <span class="selected-chip">{{ item.serviceItem }}</span>
                }
              </div>
            </div>
          }
        </aside>
      </div>
    }
  </div>

  <div class="pricing-modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="isGenerating || isLoading || pricingItems.length === 0"
      (click)="generate()"
    >
      <i class="bi bi-lightning-charge-fill me-2"></i>
      {{ isGenerating ? 'Generating...' : 'Generate' }}
    </button>
  </div>
</div>
